<template>
  <v-dialog
    v-model="dialog"
    persistent
    transition="dialog-bottom-transition"
    fullscreen
    hide-overlay
  >
    <v-card tile v-if="selectedEmployee">
      <v-toolbar dark color="primary">
        <v-toolbar-title class="font-weight-bold text-capitalize">{{
          selectedEmployee.name
        }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-dialog v-model="loadingClockIn" persistent width="300">
        <v-card color="primary" class="rounded-lg" dark>
          <v-card-text class="py-6">
            Please stand by
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-container
        grid-list-lg
        class="touch-view-container-pin d-flex align-center"
      >
        <v-layout column justify-center align-center class="my-1" fill-height>
          <v-flex class="text-h6 pt-3 text-capitalize">
            {{ selectedEmployee.name }}
          </v-flex>
          <v-flex class="text-h3 pb-3">
            {{ timeClockStatus }}
          </v-flex>

          <keypadInput ref="keypadInput" @pinValueSubmit="pinValueSubmit" />
        </v-layout>
      </v-container>

      <Submit
        :setting="integration"
        :employeeImage="image"
        :status="selectedEmployee.status"
        :openSubmitDialog="openSubmitDialog"
        @closeSubmitDialog="close"
        :employee="selectedEmployee"
      />

      <v-bottom-navigation height="70" dark>
        

        <v-btn @click="changePin()">
          <span>Change Pin</span>

          <v-icon>mdi-dialpad</v-icon>
        </v-btn>

        <!-- <v-btn @click="showPasswordDialog = true">
          <span>Add Fingerprint</span>
          <v-icon>mdi-fingerprint</v-icon>
        </v-btn> -->

        <!-- <AdminPasswordDialog
          :show="showPasswordDialog"
          @update:show="showPasswordDialog = $event"
          @close="showPasswordDialog = false"
          @authenticated="startFingerprintEnrollment"
        /> -->

      </v-bottom-navigation>
    </v-card>
  </v-dialog>
</template>

<script>
// import UserImg from "@/assets/images/user.jpeg";
import timeClockService from "@/modules/TimeClock/service.js";
import authService from "@/modules/Authentication/service.js";
import keypadInput from "@/modules/TimeClock/components/keypad-input.vue";
import Submit from "@/modules/TimeClock/components/submit.vue";
import settingService from "@/modules/Settings/service.js";
// import AdminPasswordDialog from "@/modules/TimeClock/components/AdminPasswordDialog.vue";

export default {
  name: "pin-number",
  props: [
    "pinDialog",
    "selectedEmployee",
    "metadata",
    "integration",
    "locationCode",
  ],
  data() {
    return {
      showPasswordDialog: false,
      value: 0,
      loadingClockIn: false,
      deviceCode: null,
      deviceName: null,
      action: null,
      openSubmitDialog: false,
      timeClock: {
        EmployeeId: null,
        pinCode: null,
      },
      pin: "",
      dialog: false,
      timeClockStatus: null,
      image: null,
    };
  },
  components: {
    Submit,
    // AdminPasswordDialog,
    keypadInput,
  },
  watch: {
    pinDialog(val) {
      // // console.log('this.$parent', this.$parent.$refs.webcom)
      this.dialog = val;
      if (
        this.selectedEmployee &&
        this.selectedEmployee.status === "clockedIn"
      ) {
        this.timeClockStatus = "Clock Out";
      } else {
        this.timeClockStatus = "Clock In";
      }
    },
    dialog(val) {
      if (val) {
        const { deviceName, deviceCode } = authService.getStoredDevice();
        this.deviceName = deviceName;
        this.deviceCode = deviceCode;

        // if (this.$refs && this.$refs.webcam) {
        //   // console.log('ref', this.$refs)
        //   this.$refs.webcam.start();
        // }
      }
    },
  },
  methods: {
    // startFingerprintEnrollment() {
    //   if (
    //     typeof window.AndroidApp !== "undefined" &&
    //     window.AndroidApp.startFingerprintEnrollment
    //   ) {
    //     this.$toast.success("Starting fingerprint enrollment...");
    //     window.AndroidApp.startFingerprintEnrollment();
    //   } else {
    //     this.$toast.error("Android app not available");
    //   }
    // },
    resetPin() {
      this.$refs.keypadInput.clearPin();
      this.pin = "";
    },
    async pinValueSubmit(val) {
      console.log('pinValueSubmit', val)
      this.loadingClockIn = true;
      this.pin = val;
      if (this.metadata && this.metadata.customClockIn.storeTimeClockImage) {
        this.image = await this.getImage();
        console.log('got image', this.image.dataUrl)
        if (this.image) this.image.status = this.status;
      }
      // this.submitPin();
      if (this.checkToken()) {
        // // console.log("have token", this.checkToken());
        this.submitWithToken();
      } else {
        // // console.log("no token");
        this.submitWithNoToken();
      }
    },
    async submitWithNoToken() {
      // console.log('submitWithNoToken no token', this.selectedEmployee.status)
      try {
        const loginInfo = {
          id: this.selectedEmployee.id,
          pin: this.pin,
          locationCode: this.locationCode,
          deviceCode: this.deviceCode,
          deviceName: this.deviceName,
        };
        await authService.authenticate(loginInfo);
        // console.log('auth', auth)
        const result = await authService.setLastEmployeeId(
          this.selectedEmployee.id
        );
        // console.log('result in no token', result)
        if (result) {
          await timeClockService.clockIn({
            EmployeeId: this.selectedEmployee.id,
            clockInNote: "Clocked In through Login Page",
            pinCode: this.pin,
          });
          this.loadingClockIn = false;
          this.openSubmitDialog = true;
          if (
            this.metadata &&
            this.metadata.customClockIn.storeTimeClockImage
          ) {
            this.image.location =
              this.selectedEmployee.LocationEmployee.LocationId;
            this.uploadImage(result.data.id, this.image);
          }
        }
      } catch (error) {
        this.resetPin();
        // console.log("error in submitWithNoToken", error);
        this.loadingClockIn = false;
        this.$toast.error(error.data ? error.data.message : "Error", {
          timeout: 2000,
        });
      }
    },
    async submitWithToken() {
      console.log("clockInOutEmployee submitWithToken", this.selectedEmployee);

      try {
        this.timeClock.EmployeeId = this.selectedEmployee.id;
        this.timeClock.pinCode = this.pin;
        this.timeClock.LocationId =
          this.selectedEmployee.LocationEmployee.LocationId;

        console.log("this.timeClock", this.timeClock);
        if (this.selectedEmployee.status === "clockedIn") {
          this.timeClock.clockOutTime = this.$moment().toISOString();
          const result = await timeClockService.clockOut(this.timeClock);
          // console.log('result clockOut', result)
          if (result) {
            this.loadingClockIn = false;
            this.openSubmitDialog = true;
            // console.log('clock out result', this.metadata.customClockIn.storeTimeClockImage)
            if (
              this.metadata &&
              this.metadata.customClockIn.storeTimeClockImage
            ) {
              this.image.location =
                this.selectedEmployee.LocationEmployee.LocationId;
              this.uploadImage(result.data.id, {
                status: this.selectedEmployee.status,
                image: this.image,
              });
            }
          }
        } else {
          this.timeClock.clockInTime = this.$moment().toISOString();
          // console.log('this.timeClock', this.timeClock)
          const result = await timeClockService.clockIn(this.timeClock);
          // console.log('result clockIn', result)
          if (result) {
            this.loadingClockIn = false;
            this.openSubmitDialog = true;
            if (
              this.metadata &&
              this.metadata.customClockIn.storeTimeClockImage
            ) {
              this.image.location =
                this.selectedEmployee.LocationEmployee.LocationId;
              this.uploadImage(result.data.id, {
                status: this.selectedEmployee.status,
                image: this.image,
              });
            }
          }
        }
        // this.closeSubmit()
      } catch (error) {
        // console.log("error in submitWithToken", error);
        this.resetPin();
        this.loadingClockIn = false;
        this.$toast.error(error.data ? error.data.message : "Error", {
          timeout: 2000,
        });
        localStorage.removeItem(`${process.env.VUE_APP_STORAGE_PREFIX}token`);
      }

      
    },
    async submitPin() {
      // console.log('clockInOutEmployee submitWithToken', this.selectedEmployee)

      try {
        this.timeClock.EmployeeId = this.selectedEmployee.id;
        this.timeClock.pinCode = this.pin;
        this.timeClock.LocationId =
          this.selectedEmployee.LocationEmployee.LocationId;

        console.log("this.timeClock", this.timeClock);
        if (this.selectedEmployee.status === "clockedIn") {
          this.timeClock.clockOutTime = this.$moment().toISOString();
          const result = await timeClockService.clockOut(this.timeClock);
          // console.log('result clockOut', result)
          if (result) {
            this.loadingClockIn = false;
            this.openSubmitDialog = true;
            // console.log('clock out result', this.metadata.customClockIn.storeTimeClockImage)
            if (
              this.metadata &&
              this.metadata.customClockIn.storeTimeClockImage
            ) {
              this.image.location =
                this.selectedEmployee.LocationEmployee.LocationId;
              this.uploadImage(result.data.id, {
                status: this.selectedEmployee.status,
                image: this.image,
              });
            }
          }
        } else {
          this.timeClock.clockInTime = this.$moment().toISOString();
          // console.log('this.timeClock', this.timeClock)
          const result = await timeClockService.clockIn(this.timeClock);
          // console.log('result clockIn', result)
          if (result) {
            this.loadingClockIn = false;
            this.openSubmitDialog = true;
            if (
              this.metadata &&
              this.metadata.customClockIn.storeTimeClockImage
            ) {
              this.image.location =
                this.selectedEmployee.LocationEmployee.LocationId;
              this.uploadImage(result.data.id, {
                status: this.selectedEmployee.status,
                image: this.image,
              });
            }
          }
        }
        // this.closeSubmit()
      } catch (error) {
        console.log("error in submitWithToken", error);
        this.resetPin();
        this.loadingClockIn = false;
        this.$swal(
          this.timeClockStatus,
          error.data ? error.data.message : "Error",
          "error"
        );
        // this.$toast.error(error.data ? error.data.message : "Error", {
        //   timeout: 2000,
        // });
        // localStorage.removeItem(`${process.env.VUE_APP_STORAGE_PREFIX}token`);
      }
    },
    changePin() {
      this.$parent.changePin();
      this.close();
    },
    async getImage() {
      // // console.log('getting image', this.$parent)
      if (this.$parent) {
        return await this.$parent.getImage();
        // return obj
        // // console.log("base64base64base64base64", base64);
        // if (base64) {
        //   const obj = {
        //     dataUrl: base64,
        //     info: {
        //       name: `${this.selectedEmployee.name
        //         .split(" ")
        //         .join("")}-${new Date().getTime()}.jpg`,
        //     },
        //   };
        //   return obj;
        // }
      }
    },
    async uploadImage(id, obj) {
      await settingService
        .uploadMedia(obj.image, { id: obj.image.location })
        .then((response) => {
          // return response;
          // console.log('response', obj, response)
          let image = {};
          if (obj.status === "clockedIn") {
            image.clockOutUrl = response.data.url;
          } else {
            image.clockInUrl = response.data.url;
          }
          // console.log('uploading image', id, image)
          timeClockService.update(id, image);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    checkToken() {
      if (localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}token`))
        return true;
    },

    close() {
      this.timeClock = {
        EmployeeId: null,
        pinCode: null,
      };
      this.openSubmitDialog = false;
      this.resetPin();
      this.$emit("close");
    },
    closeSubmit() {
      this.pin = "";
      this.timeClock = {
        EmployeeId: null,
        pinCode: null,
      };
      this.timeClockStatus = null;
      this.resetPin();
      this.$emit("closeSubmit");
    },
  },
};
</script>

<style scoped>
.touch-view-container-pin {
  height: calc(100vh - 126px);
  width: 95% !important;
}
</style>